import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Store} from '@ngxs/store';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private readonly store: Store) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let resultingRequest = request;
    if (!(request.url.includes('start') || request.url.includes('configurationExtended'))) {
      let authToken = this.store.selectSnapshot((state: any) => state.whitebricks.token);
      if (!authToken) {
        const flowId = this.store.selectSnapshot((state: any) => state.whitebricks.flowId);
        const sessions = this.store.selectSnapshot((state: any) => state.whitebricks.sessions);
        authToken = sessions[flowId];
      }
      resultingRequest = request.clone({
        headers: request.headers.set('Authorization', authToken ? authToken : '')
      });
    }
    return next.handle(resultingRequest);
  }
}

